import { Box, Table, Thead, Tbody, Tr, Th, Td, TableContainer } from '@chakra-ui/react';

export const TableRenderer = ({ block, data }) => {
    const rows = data?.[block.dataKey] ?? [];
    if (!rows.length) return null;

    return (
        <Box mt={3} borderWidth="1px" borderColor="gray.200" borderRadius="lg" overflow="hidden">
            <TableContainer>
                <Table size="sm" variant="simple">
                    <Thead bg="gray.50">
                        <Tr>
                            {block.columns.map((col, i) => (
                                <Th key={col.key} fontSize="2xs" color="gray.500" fontWeight="semibold" textTransform="uppercase" letterSpacing="wide" py={2.5}>
                                    {col.label}
                                </Th>
                            ))}
                        </Tr>
                    </Thead>
                    <Tbody>
                        {rows.map((row, i) => (
                            <Tr key={i} _hover={{ bg: 'blue.50' }}>
                                {block.columns.map((col, ci) => (
                                    <Td key={col.key} fontSize="xs" color={ci === 0 ? 'gray.800' : 'gray.600'} fontWeight={ci === 0 ? 'medium' : 'normal'} py={2.5}>
                                        {row[col.key]}
                                    </Td>
                                ))}
                            </Tr>
                        ))}
                    </Tbody>
                </Table>
            </TableContainer>
        </Box>
    );
};
